import { render, staticRenderFns } from "./StarReview.vue?vue&type=template&id=305d45ee&"
import script from "./StarReview.vue?vue&type=script&lang=js&"
export * from "./StarReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports